import { render, staticRenderFns } from "./bot.spinner.vue?vue&type=template&id=b0a42c58&"
import script from "./bot.spinner.vue?vue&type=script&lang=js&"
export * from "./bot.spinner.vue?vue&type=script&lang=js&"
import style0 from "./bot.spinner.vue?vue&type=style&index=0&id=b0a42c58&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\public\\Isaura\\id.es6.vn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0a42c58')) {
      api.createRecord('b0a42c58', component.options)
    } else {
      api.reload('b0a42c58', component.options)
    }
    module.hot.accept("./bot.spinner.vue?vue&type=template&id=b0a42c58&", function () {
      api.rerender('b0a42c58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bot/spinner/bot.spinner.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/bot/spinner/bot.spinner.vue
// module id = 699
// module chunks = 0 1 2 3 4 5 6 7 8 11